import { LocationVarKey } from "@swivl-mono/types";
import { ComponentType } from "react";

// ─── Access ─────────────────────────────────────────────────────────────
import { GateCodeTopic, TOPIC_VARS as gateCodeVars } from "./Access/GateCode.Topic";
import { CustomInstructionsTopic, TOPIC_VARS as customInstructionsVars } from "./Conduct/CustomInstructions.Topic";
import { WelcomeMessagesTopic, TOPIC_VARS as welcomeMessagesVars } from "./CustomerLifecycle/WelcomeMessages.Topic";
// ─── Escalations ────────────────────────────────────────────────────────
import { EscalationPushbackTopic, TOPIC_VARS as escalationPushbackVars } from "./Escalations/EscalationPushback.Topic";
import { ProfanityHandlingTopic, TOPIC_VARS as profanityHandlingVars } from "./Escalations/ProfanityHandling.Topic";
// ─── Features & Amenities ───────────────────────────────────────────────
import { AmenitiesAndServicesTopic, TOPIC_VARS as amenitiesAndServicesVars } from "./FeaturesAmenities/AmenitiesAndServices.Topic";
import { DiscountsTopic, TOPIC_VARS as discountsVars } from "./FeaturesAmenities/Discounts.Topic";
import { FacilityInfoTopic, TOPIC_VARS as facilityInfoVars } from "./FeaturesAmenities/FacilityInfo.Topic";
import { URLsTopic, TOPIC_VARS as urlsVars } from "./FeaturesAmenities/URLs.Topic";
// ─── Leads ──────────────────────────────────────────────────────────────
import { LeadCreationTopic, TOPIC_VARS as leadCreationVars } from "./Leads/LeadCreation.Topic";
// ─── Lease ──────────────────────────────────────────────────────────────
import { MoveOutTopic, TOPIC_VARS as moveOutVars } from "./Lease/MoveOut.Topic";
// ─── Website ────────────────────────────────────────────────────────────
import { WebsiteIntegrationTopic, TOPIC_VARS as websiteIntegrationVars } from "./Website/WebsiteIntegration.Topic";

/**
 * Registry of the surviving typed Cortex topic components. These render as
 * Details v3 pages via `CortexTopicWorksheet` — the Cortex v3 tab and all
 * prose-policy topic pages were removed with the Policy Builder cutover
 * (operator policies now live on the Policies tab as structured worksheets).
 *
 * See docs/snowy/plans/2026-07-15-policy-builder-bot-cutover.md §6.2.
 */
export const TOPIC_COMPONENTS: Record<string, ComponentType> = {
  // Access
  "gate-code": GateCodeTopic,

  // Escalations
  "profanity-handling": ProfanityHandlingTopic,
  "escalation-pushback": EscalationPushbackTopic,

  // Conduct (ENG-3357) — Swivl-staff custom instructions, bottom of the Policies list
  "custom-instructions": CustomInstructionsTopic,

  // Features & Amenities
  "facility-info": FacilityInfoTopic,
  "amenities-and-services": AmenitiesAndServicesTopic,
  urls: URLsTopic,
  discounts: DiscountsTopic,

  // Lease
  "move-out": MoveOutTopic,

  // Leads
  "lead-creation": LeadCreationTopic,

  // Customer Lifecycle
  "welcome-messages": WelcomeMessagesTopic,

  // Website
  website: WebsiteIntegrationTopic
};

export const TOPIC_VARS_BY_ID: Record<string, LocationVarKey[]> = {
  "gate-code": gateCodeVars,

  "profanity-handling": profanityHandlingVars,
  "escalation-pushback": escalationPushbackVars,

  "custom-instructions": customInstructionsVars,

  "facility-info": facilityInfoVars,
  "amenities-and-services": amenitiesAndServicesVars,
  urls: urlsVars,
  discounts: discountsVars,

  "move-out": moveOutVars,

  "lead-creation": leadCreationVars,

  "welcome-messages": welcomeMessagesVars,

  website: websiteIntegrationVars
};
